<script>
export default {
  name: "CashFlowHyperlink",
  functional: true,
  props: {
    openDrawer: {
      type: Function
    },
    percentFormat: {
      type: Boolean
    }
  },

  render(createElement, context) {
    //console.log("ENTRO AL context: ", context);
    let column = context.data.attrs.column;
    let row = context.data.attrs.row;
    //console.log("ROW: ", row);
    let element;
    let cellValue = Number(context.data.attrs.rowValue);
    const formatter = new Intl.NumberFormat("es-DO", {
      stlye: "currency",
      currency: "DOP"
    });
    let classs = "";
    /*   else */

    if (
      /*
       */
      !context.data.attrs.row.Responsable &&
      context.data.attrs.row.ResponsableId > 0
    ) {
      element = "";
    } else if (context.props.percentFormat) {
      if (cellValue == 0) {
        classs = "black";
      } else if (cellValue < 90) {
        classs = "red";
      } else if (cellValue >= 90 && cellValue < 95) {
        classs = "golden";
      } else if (cellValue >= 95) {
        classs = "green";
      }
      cellValue = cellValue.toString() + "%";
      context.data.attrs.rowValue = cellValue;
      element = createElement(
        "span",
        {
          attrs: {
            href: "#",
            class: classs
          },
          on: {
            click: () => {
              let tableCell = context.data.attrs;
              if (context.props.openDrawer) {
                context.props.openDrawer(tableCell.row, tableCell.column);
              }
            }
          }
        },
        context.data.attrs.rowValue
      );
    } else if (
      (cellValue > 0 && column == "SubTotal") ||
      (cellValue > 0 && context.data.attrs.row.Name == "Total de Ingresos") ||
      (cellValue > 0 && context.data.attrs.row.Name == "Total de Pagos") ||
      (cellValue > 0 && context.data.attrs.row.Name == "Utilidad Ingresos")
    ) {
      element = createElement(
        "span",
        /*
        {
          attrs: {
            class: "white"
          }
        },
        */
        formatter.format(context.data.attrs.rowValue)
      );
    } else if (cellValue > 0 && column != "SubTotal") {
      //console.log("Entre aqui porque si tu mai")
      if ("colorNegro" in row || "colorRojo" in row || "colorVerde" in row) {
        //console.log(" Tiene la propiedad")
        if (
          (row.colorNegro != null ||
            row.colorRojo != null ||
            row.colorVerde != null) &&
          (row.colorNegro.length > 0 ||
            row.colorRojo.length > 0 ||
            row.colorVerde.length > 0)
        ) {
          let months = {
            January: 1,
            Febraury: 2,
            March: 3,
            April: 4,
            May: 5,
            June: 6,
            July: 7,
            August: 8,
            September: 9,
            October: 10,
            November: 11,
            December: 12
          };
          //console.log("month : ", months[column])
          if (
            row.colorNegro.includes(months[column]) &&
            !row.colorRojo.includes(months[column]) &&
            !row.colorVerde.includes(months[column])
          ) {
            classs = "black";
          } else if (row.colorRojo.includes(months[column])) {
            classs = "red";
          } else if (row.colorVerde.includes(months[column])) {
            classs = "green";
          }

          element = createElement(
            "a",
            {
              attrs: {
                href: "#",
                class: classs
              },
              on: {
                click: () => {
                  let tableCell = context.data.attrs;
                  if (context.props.openDrawer) {
                    context.props.openDrawer(tableCell.row, tableCell.column);
                  }
                }
              }
            },
            formatter.format(cellValue)
          );
        } else if (
          row.Name == "Disponibilidad inicio de mes" ||
          row.Name == "Disponible"
        ) {
          if (cellValue <= 0) {
            classs = "red";
          } else {
            classs = "";
          }

          element = createElement(
            "p",
            {
              attrs: {
                class: classs
              } /*,
            on: {
              click: () => {
                let tableCell = context.data.attrs;
                if (context.props.openDrawer) {
                  context.props.openDrawer(tableCell.row, tableCell.column);
                }
              }
            }*/
            },
            formatter.format(cellValue)
          );
        }

        /* else */
      } else {
        element = createElement(
          "a",
          {
            attrs: {
              href: "#"
            },
            on: {
              click: () => {
                let tableCell = context.data.attrs;
                if (context.props.openDrawer) {
                  context.props.openDrawer(tableCell.row, tableCell.column);
                }
              }
            }
          },
          formatter.format(context.data.attrs.rowValue)
        );
      }
    } else if (
      row.Name == "Disponibilidad inicio de mes" ||
      row.Name == "Disponible"
    ) {
      if (cellValue <= 0) {
        classs = "red";
      } else {
        classs = "white";
      }

      element = createElement(
        "p",
        {
          attrs: {
            class: classs
          } /*,
            on: {
              click: () => {
                let tableCell = context.data.attrs;
                if (context.props.openDrawer) {
                  context.props.openDrawer(tableCell.row, tableCell.column);
                }
              }
            }*/
        },
        formatter.format(cellValue)
      );
    } else {
      //console.log("hola te estoy jodiendo", cellValue, column, row.UserName);
      element = "";
      /*
      element = createElement(
        "a",
        {
          attrs: {
            href: "#"
          },
          on: {
            click: () => {
              let tableCell = context.data.attrs;
              if (context.props.openDrawer) {
                context.props.openDrawer(tableCell.row, tableCell.column);
              }
            }
          }
        },
        formatter.format(context.data.attrs.rowValue)
      );
      */
    }
    return element;
  }
};
</script>

<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
.black {
  color: black;
}
.white {
  color: white;
}
</style>
